module.exports = __webpack_public_path__ + "img/primary-arrow.b807c6f4.svg";